import { publicEnv } from "@/config/env";
import ProductDetails from "@/features/products/components/product-details";
import { NotFoundPage } from "@/features/shared/components/not-found-page";
import { appDetailTitleHead } from "@/lib/app-document-title";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/articlegroups/$id/$plu")({
  head: () => appDetailTitleHead("products"),
  component: ArticlegroupProductPage
});

function ArticlegroupProductPage() {
  if (publicEnv.USE_ARTICLE_GROUP === "false") {
    return <NotFoundPage />;
  }

  return (
    <div className="w-full">
      <ProductDetails />
    </div>
  );
}
